(function(){
  document.querySelectorAll('.pph3').forEach(function(root){ if(root.dataset.pph3Init) return; root.dataset.pph3Init='1';
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scene=root.querySelector('.pph3-scene');
  var stage=root.querySelector('.pph3-stage');
  var layers=root.querySelectorAll('[data-depth]');
  /* Cursor tilt — pointer devices only */
  if(!reduce && root.dataset.tilt==='true' && window.matchMedia('(hover:hover) and (pointer:fine)').matches && scene){
    var raf=null, tx=0, ty=0;
    function apply(){
      raf=null;
      scene.style.setProperty('--ry', (tx*10).toFixed(2)+'deg');
      scene.style.setProperty('--rx', (-ty*8).toFixed(2)+'deg');
      layers.forEach(function(l){
        var d=parseFloat(l.dataset.depth)||1;
        l.style.translate=(tx*14*d).toFixed(1)+'px '+(ty*10*d).toFixed(1)+'px';
      });
    }
    root.addEventListener('pointermove', function(e){
      var r=stage.getBoundingClientRect();
      tx=((e.clientX-(r.left+r.width/2))/r.width);
      ty=((e.clientY-(r.top+r.height/2))/r.height);
      tx=Math.max(-.6,Math.min(.6,tx)); ty=Math.max(-.6,Math.min(.6,ty));
      if(!raf) raf=requestAnimationFrame(apply);
    });
    root.addEventListener('pointerleave', function(){ tx=0; ty=0; if(!raf) raf=requestAnimationFrame(apply); });
  }
  /* Drifting particles — cheap 2D canvas, pauses when off-screen */
  var c=root.querySelector('.pph3-particles');
  if(c && !reduce && c.getContext){
    var ctx=c.getContext('2d'), P=[], W=0, H=0, running=false, id=null;
    function size(){ var r=root.getBoundingClientRect(); W=c.width=Math.floor(r.width); H=c.height=Math.floor(r.height); }
    function seed(){ P=[]; var n=Math.min(70, Math.floor(W*H/22000)); for(var i=0;i<n;i++) P.push({x:Math.random()*W,y:Math.random()*H,r:Math.random()*1.8+.4,vx:(Math.random()-.5)*.15,vy:-(Math.random()*.25+.08),a:Math.random()*.5+.2,g:Math.random()<.18}); }
    function draw(){
      ctx.clearRect(0,0,W,H);
      for(var i=0;i<P.length;i++){ var p=P[i]; p.x+=p.vx; p.y+=p.vy; if(p.y<-4){p.y=H+4;p.x=Math.random()*W} if(p.x<-4)p.x=W+4; if(p.x>W+4)p.x=-4;
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,6.283); ctx.fillStyle=p.g?'rgba(240,208,32,'+p.a+')':'rgba(140,200,255,'+p.a+')'; ctx.fill(); }
      id=requestAnimationFrame(draw);
    }
    function start(){ if(running) return; running=true; size(); seed(); draw(); }
    function stop(){ running=false; if(id) cancelAnimationFrame(id); id=null; }
    if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ es.forEach(function(e){ e.isIntersecting?start():stop(); }); },{threshold:.05}).observe(root); } else { start(); }
    var t; window.addEventListener('resize', function(){ clearTimeout(t); t=setTimeout(function(){ if(running){ size(); seed(); } },150); });
  }
});
})();
